export const pxToRem = (px: number): string => {
    return `${px / 10}rem`
}
